import { useState } from 'react'
import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { DlcCharacters } from './DlcCharacters'
import { DlcLimitedTime } from './DlcLimitedTime'
import { DlcSteamLaunch } from './DlcSteamLaunch'
export const DLC = () => {
    const dlcannounce = [
        {
            date: 'Releases February 20, 2025',
            characters: ' Castille et Walnut',
            game: 'Phantom Brave',
            gamelink: 'https://nisamerica.com/phantombrave-remastered/',
            inpagelink: 1,
            nswlink:
                'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-Parallel-Siblings-2742463.html',
            ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00002',
            ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00001',
        },
        {
            date: 'Releases February 27, 2025',
            characters: 'Scarlet et Germe',
            game: 'Phantom Brave',
            gamelink: 'https://nisamerica.com/phantombrave-remastered/',
            inpagelink: 3,
            nswlink:
                'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-Heroes-of-the-Past-2742475.html',
            ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00002',
            ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00002',
        },
        {
            date: 'Releases March 6, 2025',
            characters: 'Vagabond',
            game: 'BAR Stella Abyss',
            gamelink: 'https://nippon1.jp/consumer/barstellaabyss/',
            inpagelink: 5,
            nswlink:
                'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Wandering-Pirate-2742471.html',
            ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00003',
            ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00003',
        },
        {
            date: 'Releases March 6, 2025',
            characters: 'Princesse',
            game: 'The Liar Princess and the Blind Prince',
            gamelink: 'https://www.nisamerica.com/the-liar-princess/',
            inpagelink: 6,
            nswlink:
                'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Liar-and-the-Lost-2742443.html',
            ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00004',
            ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00004',
        },
        {
            date: 'Releases March 13, 2025',
            characters: 'Jeune fille',
            game: 'Yomawari: Night Alone',
            gamelink: 'https://nisamerica.com/yomawari/',
            inpagelink: 7,
            nswlink:
                'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Girl-Who-Cried-Ghost-2742439.html',
            ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00005',
            ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00005',
        },
        {
            date: 'Releases March 13, 2025',
            characters: 'Rat fou et Cœur',
            game: 'MAD RAT DEAD',
            gamelink: 'https://www.nisamerica.com/mad-rat-dead/',
            inpagelink: 8,
            nswlink:
                'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Rat-Who-Demons-Fear-2742451.html',
            ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00006',
            ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00006',
        },
    ]
    const navigate = useNavigate()
    const [activeCharTab, setActiveCharTab] = useState('dlc-steamlaunch')
    const handleNavigate = (num) => {
        navigate(`/characters?tab=dlc&scrollTo=dlc-char-${num}`)
    }
    return (
        <>
            <div className='py-12 w-full text-center mx-auto'>
                <span className='newicon-mobilenav relative pt-2'>
                    <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>DLC</h1>{' '}
                </span>{' '}
            </div>{' '}
            <div className='lg:px-12 mt-20'>
                <div className='flex flex-wrap [&>button]:w-[47%] [&>button]:md:w-[24%] [&>button]:max-w-[280px] justify-center gap-4  items-start'>
                    <button>
                        <span className='relative inline-block'>
                            <img
                                onClick={() => {
                                    setActiveCharTab('dlc-characters')
                                }}
                                className={`${
                                    activeCharTab === 'dlc-characters' && 'brightness-150'
                                } hover:brightness-150 duration-300 mx-auto`}
                                src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-wood-dlc-characters-fr.webp`}
                                alt='characters'
                            />{' '}
                        </span>
                    </button>{' '}
                    <button>
                        {' '}
                        <span className='relative inline-block '>
                            <img
                                onClick={() => {
                                    setActiveCharTab('dlc-limited')
                                }}
                                className={`${
                                    activeCharTab === 'dlc-limited' && 'brightness-150'
                                } hover:brightness-150 duration-300 mx-auto `}
                                src={`${process.env.PUBLIC_URL}/images/dlc/header-limited-time-dlc-fr.webp`}
                                alt='phantoms'
                            />{' '}
                        </span>
                    </button>{' '}
                    <button>
                        {' '}
                        <span className='relative inline-block newicon'>
                            <img
                                onClick={() => {
                                    setActiveCharTab('dlc-steamlaunch')
                                }}
                                className={`${
                                    activeCharTab === 'dlc-steamlaunch' && 'brightness-150'
                                } hover:brightness-150 duration-300 mx-auto `}
                                src={`${process.env.PUBLIC_URL}/images/dlc/header-steam-launch-bonus-fr.webp`}
                                alt='dlc steam launch bonus'
                            />{' '}
                        </span>
                    </button>{' '}
                </div>{' '}
                {(() => {
                    switch (activeCharTab) {
                        case 'dlc-characters':
                            return <DlcCharacters />
                        case 'dlc-limited':
                            return <DlcLimitedTime />
                        case 'dlc-steamlaunch':
                            return <DlcSteamLaunch />

                        default:
                            return null
                    }
                })()}
             
            </div>
        </>
    )
}
